import type { BaseElement } from 'slate';

import type { UUID } from '../../../types/type-helpers';
import type {
  AlineTextFormats,
  ParagraphElement,
  ParagraphListProps,
  SuggestedListEdit,
} from '../../internal';

/**
 * @deprecated
 */
export type ListType = 'list';
/**
 * @deprecated
 */
export const listType: ListType = 'list';

export enum ListMarkerStyleName {
  // Unordered
  BLACK_CIRCLE = 'black-circle',
  BLACK_DIAMOND_BLACK_CIRCLE = 'black-diamond',
  BLACK_DIAMOND_MINUS_WHITE_X = 'black-diamond-minus-white-x',
  BLACK_SQUARE = 'black-square',
  BLACK_STAR = 'black-star',
  BULLET = 'bullet',

  // Custom made
  CUSTOM = 'custom',

  // Ordered
  DECIMAL = 'decimal',
  DECIMAL_LEADING_ZERO = 'decimal-leading-zero',

  DECIMAL_SECTION = 'decimal-section',
  LOWER_LATIN = 'lower-latin',
  LOWER_RIGHT_SHADOWED_WHITE_SQUARE = 'lower-right-shadowed-white-square',
  LOWER_ROMAN = 'lower-roman',
  RIGHTWARDS_ARROW = 'rightwards-arrow',
  THREE_D_TOP_LIGHTED_RIGHTWARDS_ARROWHEAD = 'three-d-top-lighted-rightwards-arrowhead',
  UPPER_LATIN = 'upper-latin',
  UPPER_ROMAN = 'upper-roman',
  WHITE_CIRCLE = 'white-circle',
}

export type ListLevel = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
/**
 * @deprecated
 */
export type ListMarkerFormats = {
  [key in ListLevel]: AlineTextFormats;
};

export interface ListMarkerNumFormat {
  name: ListMarkerStyleName;
  customText?: string;
  /** @deprecated Prefer just using customText. */
  prefix?: string;
  /** @deprecated Prefer just using customText. */
  suffix?: string;
}

export type ListMarkerStyles = {
  [key in ListLevel]: ListMarkerNumFormat;
};

/**
 * Modeled after the `lvlJc` XML tag in OOXML.
 * See http://officeopenxml.com/WPnumbering-lvlJc.php or ECMA Spec 17.9.7.
 * For now, we only support start and end as values, although there are many more.
 */
export enum ListLevelAlignment {
  End = 'end',
  Start = 'start',
}

export interface ListLevelDefinition {
  style: ListMarkerNumFormat;
  alignment?: ListLevelAlignment;
  markerFormats?: Partial<AlineTextFormats>;
  start?: number;
}

export type ListDefinition = {
  [key in ListLevel]: ListLevelDefinition;
};
export type ListDefinitions = Record<UUID, ListDefinition>;

/**
 * @deprecated
 */
export interface ListElement extends BaseElement {
  children: ParagraphElement[];
  markerFormats: ListMarkerFormats;
  markerStyles: ListMarkerStyles;
  type: ListType;
  suggestedEdits?: SuggestedListEdit[] | null;
}

/**
 * @deprecated
 */
export type ListProps = Omit<ListElement, 'children'>;

export interface ListItemElement extends ParagraphElement {
  // @deprecated
  listLevel: ListLevel;
  listProps: ParagraphListProps;
}

export type ListItemProps = Omit<ListItemElement, 'children'>;
